import { Col, Row } from 'react-bootstrap';
import { BookOpen } from 'lucide-react';

const Hero = () => {
    return (
        <section
            className="position-relative overflow-hidden"
            style={{
                paddingTop: 'clamp(4rem, 8vw, 7rem)',
                paddingBottom: 'clamp(3rem, 6vw, 5rem)',
            }}
        >
            {/* Decorative elements */}
            <div
                style={{
                    position: 'absolute',
                    top: '-40%',
                    right: '-10%',
                    width: '500px',
                    height: '500px',
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(38,162,171,0.15) 0%, transparent 70%)',
                    pointerEvents: 'none',
                }}
            />
            <div
                style={{
                    position: 'absolute',
                    bottom: '-30%',
                    left: '-5%',
                    width: '400px',
                    height: '400px',
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(36,52,125,0.1) 0%, transparent 70%)',
                    pointerEvents: 'none',
                }}
            />

            <Row className="justify-content-center position-relative" style={{ zIndex: 1 }}>
                <Col lg={8} xl={7} className="text-center">
                    {/* Icon badge */}
                    <div
                        className="d-inline-flex align-items-center mb-3"
                        style={{
                            gap: '8px',
                            background: 'rgba(255,255,255,0.12)',
                            backdropFilter: 'blur(8px)',
                            borderRadius: '50px',
                            padding: '8px 20px',
                            border: '1px solid rgba(255,255,255,0.18)',
                        }}
                    >
                        <BookOpen size={16} color="#2dd4bf" />
                        <span style={{ fontSize: '0.8rem', fontWeight: 600, color: '#fff', letterSpacing: '1px', textTransform: 'uppercase' }}>
                            Our Blog
                        </span>
                    </div>

                    <h1
                        className="text-white mb-4"
                        style={{
                            fontSize: 'clamp(1.75rem, 4vw, 2.75rem)',
                            fontWeight: 800,
                            lineHeight: 1.2,
                            letterSpacing: '-0.02em',
                        }}
                    >
                        Sales & CRM Blog –{' '}
                        <span style={{ color: '#2dd4bf' }}>Insights</span>, Lead Management &{' '}
                        <span style={{ color: '#2dd4bf' }}>Tracking Strategies</span>
                    </h1>

                    <p
                        className="mx-auto"
                        style={{
                            color: 'rgba(255,255,255,0.8)',
                            fontSize: 'clamp(0.9rem, 1.5vw, 1.05rem)',
                            lineHeight: 1.8,
                            maxWidth: '640px',
                        }}
                    >
                        Discover how <strong style={{ color: '#fff' }}>Sales Trackify</strong> empowers businesses to streamline sales tracking and optimize performance.
                        Get expert tips, case studies, and industry trends to drive revenue growth.
                    </p>
                </Col>
            </Row>
        </section>
    );
};

export default Hero;
